import name from './name'

const selectSliceData = state => state[name]
const selectSections = state => selectSliceData(state).sections

export { selectSections }
